import {Instance, types} from 'mobx-state-tree';
import {EntityBaseInfo} from 'core/models';

const SampleInfo = types.compose(EntityBaseInfo, types.model('SampleInfo', {}));

export type TSampleInfoModel = Instance<typeof SampleInfo>;

export {SampleInfo};
